import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import LiveFeed from '../LiveFeed';
import playMetricsDataSource from '@gameday/core/datasources/playMetrics';
import contentDataSource from '@gameday/core/datasources/content';
import contentGraphDataSource from '@gameday/core/datasources/contentGraph';
import liveFeedDataRequestAction from '../store/actions/liveFeedDataRequestAction';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import { getLiveFeedState } from '../store/selectors/getLiveFeedState';
import playReducer from '../../Play/store/reducers/play';
import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';

const fetchData = () => {
    return liveFeedDataRequestAction();
};

initContainerData.register({
    datasources: {
        playMetrics: playMetricsDataSource,
        content: contentDataSource,
        contentGraph: contentGraphDataSource
    },
    reducers: {
        play: playReducer
    }
});

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const LiveFeedDataContainer = (props) => {
    const {
        playsByInning,
        isLoading
    } = useSelector(getLiveFeedState);

    return (
        <ErrorBoundaryWrapper componentName='Live feed'>
            <LiveFeed
                { ...props }
                isLoading={ isLoading }
                playsByInning={playsByInning}
            />
        </ErrorBoundaryWrapper>
    );
};

LiveFeedDataContainer.propTypes = {
    openAtBatOverlay: PropTypes.func,
    reverseChron: PropTypes.bool,
    showAllPitches: PropTypes.bool,
    showAnimations: PropTypes.bool,
    showFieldView: PropTypes.bool,
    isSingleCol: PropTypes.bool
};

export default LiveFeedDataContainer;
export { fetchData, routes };
